export default __webpack_public_path__ + "static/media/TSC244 PRO.3c452af5.jpg";